import React from 'react';

const ForecastMetric = ({ label, value, detail, tone = 'blue' }) => {
  const tones = {
    blue: 'bg-blue-50 border-blue-100 text-blue-700',
    emerald: 'bg-emerald-50 border-emerald-100 text-emerald-700',
    amber: 'bg-amber-50 border-amber-100 text-amber-700',
    slate: 'bg-slate-50 border-slate-200 text-slate-700'
  };

  return (
    <div className={`rounded-2xl border p-5 ${tones[tone] || tones.blue}`}>
      <p className="text-[10px] font-black uppercase tracking-widest opacity-70">{label}</p>
      <p className="mt-2 text-2xl font-black text-slate-900">{value}</p>
      <p className="mt-1 text-xs font-medium opacity-75">{detail}</p>
    </div>
  );
};

export default ForecastMetric;